import { sanitizeForumHtml } from './forumContent';

// Only sanitized content receives controls: users cannot supply buttons, data
// attributes or event handlers to this interaction boundary.
export function forumImageContent(html) {
  const template = document.createElement('template');
  template.innerHTML = sanitizeForumHtml(html);
  const images = [];
  template.content.querySelectorAll('img').forEach(img => {
    const index = images.length;
    const image = { src: img.getAttribute('src'), alt: img.getAttribute('alt') || '' };
    images.push(image);
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'forum-next-image-trigger';
    button.setAttribute('data-forum-image', String(index));
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-label', image.alt ? 'Ampliar imagen: ' + image.alt : 'Ampliar imagen ' + (index + 1));
    const link = img.closest('a[href]');
    if (link) {
      // Preserve linked images without nesting a button in their anchor.
      button.classList.add('forum-next-image-trigger--linked');
      button.textContent = 'Ampliar imagen'; link.after(button);
    } else {
      img.replaceWith(button); button.appendChild(img);
      const hint = document.createElement('span');
      hint.className = 'forum-next-image-hint'; hint.textContent = 'Ampliar imagen';
      button.appendChild(hint);
    }
  });
  return { html: template.innerHTML, images };
}
